<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumb"></ZD-bread-crumb>
    </div>

    <div class="list-content-div">
      <div class="list-header-row">
        <div class="list-header-title-div">空开代理商管理</div>
        <div class="page-action-btns flex">
          <button class="common-bg-button" @click="search">查 询</button>
          <button class="common-bg-button" @click="toggleFilters">高级筛选</button>
          <button class="common-bg-button" @click="handleAddAgent">添加代理商</button>
        </div>
      </div>

      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyWord" size="small" placeholder="请输入代理商名称/账号"></el-input>
            </el-col>
            <!-- <el-col :span="6">
              <p class="margin-bottom-5 font-14">代理商级别</p>
              <el-select v-model="queryInfo.agentLevel" size="small" placeholder="请选择" style="width: 100%"
                @change="getListData(pagination, true)">
                <el-option label="一级" :value="1" />
                <el-option label="二级" :value="2" />
              </el-select>
            </el-col> -->
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">创建时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="createTime" @change="pickCreateTime(createTime)" range-separator="-" start-placeholder="开始时间"
                end-placeholder="结束时间" style="width: 100%">
              </el-date-picker>
            </el-col>
          </el-row>
        </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="reset">重 置</button>
          <button class="common-bg-button" @click="search">搜 索</button>
        </div>
      </div>

      <el-table :data="agentList" size="small" border style="width: 100%">
        <el-table-column prop="activityName" label="关联活动" min-width="140">
          <template slot-scope="{ row }">{{ row.activityName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="agentName" label="代理商名称" min-width="180">
          <template slot-scope="{ row }">
            <span v-if="row.agentLevel === '2' || row.agentLevel === 2" class="agent-level-indent">L {{ row.agentName ||
              '-' }}</span>
            <span v-else>{{ row.agentName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="账号(手机号)" min-width="130">
          <template slot-scope="{ row }">{{ row.phone || row.mobile || row.account || '-' }}</template>
        </el-table-column>
        <el-table-column prop="agentLevel" label="代理商级别" min-width="110">
          <template slot-scope="{ row }">
            <span v-if="row.agentLevel" class="level-tag" :class="getLevelTagClass(row.agentLevel)">
              {{ getAgentLevelText(row.agentLevel) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="relationAgent" label="关联代理商" min-width="180">
          <template slot-scope="{ row }">
            <span v-if="(row.childrenCount ?? 0) > 0" class="link-text" @click="handleSubAgentClick(row)">
              ↓下级 {{ row.childrenCount }}个代理商
            </span>
            <span v-else-if="row.parentId" class="link-text" @click="handleParentAgentClick(row)">
              ↑上级
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.statusEnabled" :active-value="true" :inactive-value="false"
              @change="handleStatusChange(row)" />
            <span class="status-text">{{ row.statusEnabled ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="qrcode" label="推广二维码" min-width="110" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" icon="el-icon-view" @click="handleViewQrcode(row)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="registeredCount" label="已报名人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.registeredCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="pendingActivateCount" label="待激活人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.pendingActivateCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="usedCount" label="已使用人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.usedCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="createdWhen" label="创建时间" min-width="170">
          <template slot-scope="{ row }">{{ row.createdWhen || row.createTime || '-' }}</template>
        </el-table-column>
      </el-table>

      <div class="list-pagination">
        <el-pagination background layout="total, prev, pager, next, sizes, jumper" :current-page="pagination.current"
          :page-size="pagination.pageSize" :page-sizes="[10, 20, 50, 100]" :total="pagination.total"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" />
      </div>

      <!-- 推广二维码弹窗 -->
      <el-dialog :title="qrcodeDialogTitle" :visible.sync="qrcodeDialogVisible" width="360px" center
        @close="qrcodeDialogVisible = false; qrcodeDataUrl = ''">
        <div class="qrcode-dialog-body" v-if="currentAgent">
          <p class="agent-name">{{ currentAgent.agentName || '-' }}</p>
          <p class="agent-info-subtitle">账号: {{ currentAgent.phone || currentAgent.mobile || currentAgent.account || '-'
          }} |
            级别: {{ getAgentLevelText(currentAgent.agentLevel) }}</p>
          <div class="qrcode-placeholder">
            <img v-if="qrcodeDataUrl" :src="qrcodeDataUrl" class="qrcode-img" alt="推广二维码" />
            <i v-else class="el-icon-picture-outline" style="font-size: 120px; color: #dcdfe6;"></i>
            <p class="qrcode-tip">扫码推广</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleDownloadQrcode">下载二维码</el-button>
          <el-button @click="qrcodeDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 添加代理商弹窗 -->
      <el-dialog title="添加代理商" :visible.sync="addAgentDialogVisible" width="550px" center @close="cancelAddAgent" :close-on-click-modal="false">
        <el-form ref="addAgentFormRef" :model="addAgentForm" :rules="addAgentRules" label-width="120px" >
          <p class="dialog-description">填写代理商信息，系统将自动生成专属二维码</p>
          <el-form-item label="代理商名称" prop="agentName">
            <el-input v-model="addAgentForm.agentName" placeholder="请输入代理商名称" clearable />
          </el-form-item>
          <el-form-item label="账号(手机号)" prop="mobile">
            <el-input v-model="addAgentForm.mobile" placeholder="请输入手机号" clearable maxlength="11" />
          </el-form-item>
          <el-form-item label="代理商级别" prop="agentLevel">
            <el-select v-model="addAgentForm.agentLevel" placeholder="请选择代理商级别" style="width: 100%" clearable
              @change="handleAgentLevelChange">
              <el-option v-for="item in agentLevelOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-alert v-if="addAgentForm.agentLevel === 'LEVEL_ONE'" title="一级代理商为顶级代理,可独立运营,不需要上级代理商" type="info"
            :closable="false" show-icon class="level-tip" />
          <template v-if="addAgentForm.agentLevel === 'LEVEL_TWO'">
            <el-alert title="二级代理商需要关联到一级代理商，享受上级代理商的资源和支持" type="info" :closable="false" show-icon class="level-tip" />
            <el-form-item label="上级代理商" prop="parentAgentId">
              <el-select v-model="addAgentForm.parentAgentId" placeholder="请选择上级代理商" style="width: 100%" clearable>
                <el-option v-for="item in parentAgentOptions" :key="item.id" :label="item.agentName" :value="item.id" />
              </el-select>
            </el-form-item>
            <p class="parent-agent-tip">选择一个一级代理商作为上级,建立代理关系</p>
          </template>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAddAgent">取 消</el-button>
          <el-button type="primary" @click="confirmAddAgent">确认添加</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  data() {
    return {
      queryInfo: {
        keyWord: "",
        agentLevel: 2, // 一级不调接口，二级调接口
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10,
      },
      createTime: [],
      showMultiQuerys: false,
      agentList: [],
      parentAgentList: [], // 一级代理商列表，选择二级时接口获取
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      qrcodeDialogVisible: false,
      currentAgent: null,
      qrcodeDataUrl: "",
      breadCrumb: [
        { name: "营销活动" },
        { name: "空开&送桩活动" },
        { name: "空开代理商管理" },
      ],
      addAgentDialogVisible: false,
      addAgentForm: {
        agentName: "",
        mobile: "",
        agentLevel: "",
        parentAgentId: "",
      },
      addAgentRules: {
        agentName: [
          { required: true, message: "请输入代理商名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
        ],
        agentLevel: [{ required: true, message: "请选择代理商级别", trigger: "change" }],
        parentAgentId: [
          {
            validator: (rule, value, callback) => {
              if (this.addAgentForm.agentLevel === "LEVEL_TWO" && !value) {
                callback(new Error("请选择上级代理商"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      agentLevelOptions: [
        { label: "一级", value: "LEVEL_ONE" },
        { label: "二级", value: "LEVEL_TWO" },
      ],
    };
  },
  computed: {
    qrcodeDialogTitle() {
      const name = this.currentAgent ? (this.currentAgent.agentName || "-") : "推广";
      return `${name} - 专属二维码`;
    },
    parentAgentOptions() {
      return this.parentAgentList;
    },
  },
  mounted() {
    this.getListData(this.pagination, true);
  },
  methods: {
    cleanQueryInfo(queryInfo) {
      const clean = {};
      Object.keys(queryInfo).forEach(key => {
        const value = queryInfo[key];
        if (value !== null && value !== undefined && value !== "") {
          clean[key] = value;
        }
      });
      return clean;
    },
    getListData(pagination, reload = false) {
      const _ = this;
      _.$U.showLoading(_);

      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 1;
      } else {
        _.pagination.current = pagination.current;
        _.queryInfo.pageNum = pagination.current;
      }
      _.queryInfo.pageSize = pagination.pageSize;

      const apiUrl = _.$A.agent?.findByPage;
      if (!apiUrl) {
        _.agentList = [];
        _.pagination.total = 0;
        _.$U.hideLoading(_);
        return;
      }

      // 主列表：一级传 1
      const ACTIVITY_NO_FIXED = "CIRCUIT_BREAKER_ACTIVITY";
      const params = {
        activityType: ACTIVITY_NO_FIXED,
        agentLevel: 1,
        keyWord: _.queryInfo.keyWord || undefined,
        startTime: _.queryInfo.startTime || undefined,
        endTime: _.queryInfo.endTime || undefined,
        pageNum: (_.queryInfo.pageNum || 1) - 1,
        pageSize: _.queryInfo.pageSize || 10,
      };
      Object.keys(params).forEach((k) => params[k] === undefined && delete params[k]);

      _.$H.post(_, apiUrl, params).then((res) => {
        // 接口返回 { data: { content: [...], totalElements: N }, status: 200 }
        const payload = res?.data?.data ?? res?.data ?? {};
        const list = payload?.content ?? payload?.list ?? payload?.records ?? [];
        _.agentList = (Array.isArray(list) ? list : []).map((item) => ({
          ...item,
          statusEnabled: item.status === "00" || item.status === "ENABLED" || item.status === 1,
        }));
        _.pagination.total = payload?.totalElements ?? payload?.total ?? 0;
      }).catch(() => {
        _.agentList = [];
        _.pagination.total = 0;
      }).finally(() => {
        _.$U.hideLoading(_);
      });
    },
    pickCreateTime(time) {
      if (time && time.length === 2) {
        const [start, end] = time;
        const startDate = start ? String(start).slice(0, 10) : "";
        const endDate = end ? String(end).slice(0, 10) : "";
        if (startDate && endDate && startDate === endDate) {
          const normalizedStart = startDate + " 00:00:00";
          const normalizedEnd = endDate + " 23:59:59";
          this.createTime = [normalizedStart, normalizedEnd];
          this.queryInfo.startTime = normalizedStart;
          this.queryInfo.endTime = normalizedEnd;
          return;
        }
      }
      this.queryInfo.startTime = time && time[0] ? time[0] : "";
      this.queryInfo.endTime = time && time[1] ? time[1] : "";
    },
    toggleFilters() {
      this.showMultiQuerys = !this.showMultiQuerys;
    },
    reset() {
      this.queryInfo = {
        keyWord: "",
        agentLevel: 2,
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10,
      };
      this.createTime = [];
      this.getListData(this.pagination, true);
    },
    search() {
      this.getListData(this.pagination, true);
    },
    handleCurrentChange(page) {
      this.pagination.current = page;
      this.getListData(this.pagination, false);
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.current = 1;
      this.getListData(this.pagination, true);
    },
    // 选择二级时调接口获取一级代理商列表
    fetchParentAgentList() {
      const _ = this;
      const apiUrl = _.$A.agent?.list;
      if (!apiUrl) {
        _.parentAgentList = [];
        return;
      }
      const params = {
        activityType: "CIRCUIT_BREAKER_ACTIVITY",
        agentLevel: 1,
        pageNum: 0,
        pageSize: 9999,
      };
      _.$H.post(_, apiUrl, params).then((res) => {
        // 接口返回 { data: [...], status: 200 }
        const list = res?.data?.data ?? res?.data ?? [];
        _.parentAgentList = Array.isArray(list) ? list : [];
      }).catch(() => {
        _.parentAgentList = [];
      });
    },
    handleAgentLevelChange() {
      if (this.addAgentForm.agentLevel !== "LEVEL_TWO") {
        this.addAgentForm.parentAgentId = "";
        this.parentAgentList = [];
      } else {
        this.fetchParentAgentList();
      }
    },
    handleAddAgent() {
      this.addAgentForm = {
        agentName: "",
        mobile: "",
        agentLevel: "",
        parentAgentId: "",
      };
      this.addAgentDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addAgentFormRef?.resetFields();
      });
    },
    confirmAddAgent() {
      this.$refs.addAgentFormRef.validate((valid) => {
        if (!valid) return;
        const apiUrl = this.$A.agent?.add;
        if (!apiUrl) {
          this.$message.warning("添加接口未配置");
          return;
        }
        const agentLevelMap = { LEVEL_ONE: 1, LEVEL_TWO: 2, LEVEL_THREE: 3 };
        const params = {
          agentName: this.addAgentForm.agentName,
          phone: this.addAgentForm.mobile,
          agentLevel: agentLevelMap[this.addAgentForm.agentLevel] || 1,
          activityType: "CIRCUIT_BREAKER_ACTIVITY",
        };
        if (this.addAgentForm.agentLevel === "LEVEL_TWO" && this.addAgentForm.parentAgentId) {
          params.parentId = this.addAgentForm.parentAgentId;
        }
        this.$U.showLoading(this);
        this.$H.post(this, apiUrl, params).then(() => {
          this.$message.success("代理商添加成功");
          this.addAgentForm = { agentName: "", mobile: "", agentLevel: "", parentAgentId: "" };
          this.parentAgentList = [];
          this.$refs.addAgentFormRef?.resetFields();
          this.addAgentDialogVisible = false;
          this.getListData(this.pagination, true);
        }).catch(() => { }).finally(() => {
          this.$U.hideLoading(this);
        });
      });
    },
    cancelAddAgent() {
      this.addAgentDialogVisible = false;
      this.$refs.addAgentFormRef?.resetFields();
    },
    handleStatusChange(row) {
      const _ = this;
      const newStatus = row.statusEnabled ? "00" : "01";
      const apiUrl = _.$A.agent?.updateAgentStatus;
      if (!apiUrl) {
        _.$message.warning("状态更新接口未配置");
        row.statusEnabled = !row.statusEnabled;
        return;
      }
      _.$U.showLoading(_);
      _.$H.post(_, apiUrl, { id: row.id, status: newStatus }).then(() => {
        _.$message.success("状态更新成功");
        _.$U.hideLoading(_);
      }).catch(() => {
        row.statusEnabled = !row.statusEnabled;
        _.$U.hideLoading(_);
      });
    },
    getPromotionQrcodeUrl(phone) {
      // alipays://platformapi/startapp?appId=2021006100663100&page=pages/activities/index&query=sharedMerchant%3D
      const base = "alipays://platformapi/startapp?appId=2021006100663100&page=pages/activities/index&query=sharedMerchant%3D";
      return base + (phone || "");
    },
    handleViewQrcode(row) {
      this.currentAgent = row;
      this.qrcodeDataUrl = "";
      this.qrcodeDialogVisible = true;
      this.$nextTick(() => this.generateQrcode());
    },
    generateQrcode() {
      if (!this.currentAgent) return;
      const phone = this.currentAgent.phone || this.currentAgent.mobile || this.currentAgent.account || "";
      const url = this.getPromotionQrcodeUrl(phone);
      QRCode.toDataURL(url, { width: 200, margin: 2 }).then((dataUrl) => {
        this.qrcodeDataUrl = dataUrl;
      }).catch(() => {
        this.$message.error("二维码生成失败");
      });
    },
    handleDownloadQrcode() {
      if (!this.currentAgent) return;
      const phone = this.currentAgent.phone || this.currentAgent.mobile || this.currentAgent.account || "";
      const url = this.getPromotionQrcodeUrl(phone);
      const fileName = `推广二维码_${(this.currentAgent.agentName || phone || "agent").replace(/[/\\?%*:|"<>]/g, "_")}.png`;
      QRCode.toDataURL(url, { width: 300, margin: 2 }).then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = fileName;
        link.click();
        this.$message.success("二维码已下载");
      }).catch(() => {
        this.$message.error("二维码下载失败");
      });
    },
    handleSubAgentClick(row) {
      // 一级代理商，查看其下级二级代理商，parentId 取当前行 id
      if (!row.id) {
        this.$message.warning("该代理商暂无下级数据");
        return;
      }
      this.$router.push({
        name: "emptySwitchAgentLevel2List",
        query: { parentId: row.id, parentAgentName: row.agentName },
      });
    },
    handleParentAgentClick(row) {
      // 二级代理商，查看同上级下的二级代理商，parentId 取当前行 parentId
      if (!row.parentId) {
        this.$message.warning("该代理商暂无上级数据");
        return;
      }
      this.$router.push({
        name: "emptySwitchAgentLevel2List",
        query: { parentId: row.parentId, parentAgentName: row.parentAgentName },
      });
    },
    getAgentLevelText(level) {
      const map = { LEVEL_ONE: "一级", LEVEL_TWO: "二级", LEVEL_THREE: "三级", "1": "一级", "2": "二级", "3": "三级", 1: "一级", 2: "二级", 3: "三级" };
      return map[level] || map[String(level)] || level || "-";
    },
    getLevelTagClass(level) {
      const map = { LEVEL_ONE: "level-one", LEVEL_TWO: "level-two", LEVEL_THREE: "level-three", "1": "level-one", "2": "level-two", "3": "level-three", 1: "level-one", 2: "level-two", 3: "level-three" };
      return map[level] || map[String(level)] || "";
    },
  },
};
</script>

<style lang="less" scoped>
.list-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-action-btns {
  gap: 12px;
}

.margin-tb-10 {
  margin: 10px 0;
}

.multi-query-div {
  padding: 16px;
  background: #f6f8fb;
  border-radius: 6px;
}

.list-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
}

.link-text {
  color: #4182eb;
  cursor: pointer;
}

.agent-level-indent {
  padding-left: 8px;
}

.level-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;

  &.level-one {
    background: #ecf5ff;
    color: #409eff;
  }

  &.level-two {
    background: #f0f9eb;
    color: #67c23a;
  }

  &.level-three {
    background: #fdf6ec;
    color: #e6a23c;
  }
}

.status-text {
  margin-left: 8px;
  font-size: 12px;
  color: #606266;
}

.qrcode-dialog-body {
  text-align: center;
  padding: 16px 0;

  .agent-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
    color: #303133;
  }

  .agent-info-subtitle {
    font-size: 14px;
    color: #606266;
    margin-bottom: 16px;
  }

  .qrcode-placeholder {
    padding: 24px;
    background: #f5f7fa;
    border-radius: 8px;

    .qrcode-img {
      width: 200px;
      height: 200px;
      display: block;
      margin: 0 auto;
    }

    .qrcode-tip {
      margin-top: 12px;
      font-size: 12px;
      color: #909399;
    }
  }
}

.dialog-description {
  text-align: center;
  color: #606266;
  font-size: 14px;
  margin-bottom: 20px;
}

.level-tip {
  margin-top: 10px;
  margin-bottom: 12px;
}

.parent-agent-tip {
  font-size: 12px;
  color: #909399;
  margin: 8px 0 16px 0;
  padding-left: 120px;
  line-height: 1.5;
}
</style>
